module.exports = [
  "Tumalo Ridge > Sector 16 > Upper Whoops > Skyliner",
  "Tumalo Ridge > Swede Ridge > Swampy > Southfork > Tumalo Creek",
  "Storm King > Tiddlywinks > Larsen's > Tyler's Traverse > Catch & Release > Storm King",
  "Tumalo Creek > Northfork > Metolius-Windigo > Mrazek > Farewell > Tumalo Creek",
  "Alpine > Tire Mountain > Cloverpatch > Alpine (ATCA)",
  "Pinedrops > Unknown > Phil's > Storm King > Grand Slam > VooDoo Child > VooDoo > Ben's",
  "EXT > Phil's > VooDoo > VooDoo Child  > Grand Slam > Storm King > Unknown > Pinedrops",
];
